"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTemplateItemCard = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledTemplateItemCard = (0, styles_1.styled)(material_1.Card)({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
});
//# sourceMappingURL=index.js.map